module.exports = __webpack_public_path__ + "img/72.b7e017e2.jpg";